export default __webpack_public_path__ + "1a399841803ee18803087c2b5657d698.svg";